import classNames from "classnames/bind";
import styles from "./Playback.module.css";
import { PlayBack } from "../../PlayBack";
import { getStatusParam } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const cx = classNames.bind(styles);

function PlaybackDesktopView(params) {
    const navigate = useNavigate();

    useEffect(() => {
        const param = getStatusParam(["token"]);
        if (param?.token) {
            localStorage?.setItem('token', param?.token);
            sessionStorage?.setItem('token', param?.token);
            const url = new URL(window.location.href);
            navigate(url?.pathname);
            window.location.reload();
        }
    }, [])
    return (
        <>
            <PlayBack />
        </>
    )
}

export default PlaybackDesktopView;